import { DateInput, DateInputProps } from '@mantine/dates';
import { parseIsoCalendarDate } from '../../helpers/isoCalendarDate';

export const CalendarDateInput = (props: DateInputProps) => (
    <DateInput {...props} valueFormat="YYYY-MM-DD" dateParser={parseIsoCalendarDate} />
);
